<div class="container-fluid px-0 overflow-hidden">
  <div class="row m-0">

    <h4 class="col-12 fw-700 mt-4 mb-3">Child Safety, Election Integrity, and Platform Neutrality</h4>
    
    <h5 class="col-12 fw-700 mt-2">1. Platform Purpose and Neutrality</h5>
    <p class="col-12 text-justify my-2">
      The App is a neutral technology platform designed to facilitate civic engagement, town-hall discussions, and public commentary related to political campaigns and public office. The App <b>does not endorse, oppose, promote, or otherwise favor any candidate, political party, or political position</b>, and all candidates using the App do so on equal terms, subject to these Terms.
    </p>
    <p class="col-12 text-justify my-2 mb-3">
      Content posted by users or candidates reflects the views of the individual speaker only and <b>does not represent the views of the App, its operators, or affiliates.</b>
    </p>
    <hr class="col-12 my-3">

    <h5 class="col-12 fw-700 mt-3">2. Child Safety and Zero-Tolerance Policy</h5>
    <p class="col-12 text-justify my-2">
      Notwithstanding the App’s civic and political purpose, we maintain a <b>zero-tolerance policy</b> for any content or conduct that exploits, endangers, abuses, or harms children. All use of the App must comply with applicable child safety and child protection laws.
    </p>
    <p class="col-12 text-justify my-2">
      Users may not create, post, upload, transmit, solicit, or otherwise engage in any content or behavior involving <b>child sexual abuse or exploitation</b>, including but not limited to:
    </p>
    <div class="col-12 text-justify list">
      <ul>
        <li>Child sexual abuse material (CSAM);</li>
        <li>Sexualization of a minor;</li>
        <li>Grooming or predatory behavior toward a minor;</li>
        <li>Sextortion involving a minor;</li>
        <li>Trafficking or solicitation of a minor for sexual or exploitative purposes; or</li>
        <li>Any conduct intended to facilitate, promote, normalize, or conceal the abuse or exploitation of a child.</li>
      </ul>
    </div>
    <p class="col-12 text-justify my-2 mb-3">
      These prohibitions apply across all App features, including public comments, live or recorded town-hall discussions, candidate Q&A features, usernames, profile information, shared links, and any interactive functionality.
    </p>
    <hr class="col-12 my-3">

    <h5 class="col-12 fw-700 mt-3">3. User-Generated Political Content</h5>
    <p class="col-12 text-justify my-2">
      The App permits users and candidates to post political speech and commentary; however, <b>political speech does not exempt content from safety or legality requirements.</b> Content that violates this Section may be removed regardless of political viewpoint, speaker identity, or campaign status.
    </p>
    <p class="col-12 text-justify my-2 mb-3">
      Moderation actions are taken <b>based on conduct and policy compliance, not political perspective.</b>
    </p>
    <hr class="col-12 my-3">

    <h5 class="col-12 fw-700 mt-3">4. Reporting, Enforcement, and Cooperation</h5>
    <p class="col-12 text-justify my-2">
      We reserve the right to remove content, restrict visibility, suspend or terminate accounts, and take other appropriate action if we become aware of content or conduct that violates this Section.
    </p>
    <p class="col-12 text-justify my-2">
      Where required or appropriate, we may report suspected child sexual abuse or exploitation to relevant authorities, including the <b>National Center for Missing & Exploited Children (NCMEC)</b> or equivalent regional authorities, and we will cooperate with law enforcement and child safety organizations.
    </p>
    <p class="col-12 text-justify my-2 mb-3">
      The App provides a mechanism for users to report comments, posts, or conduct that may violate these Terms or endanger children. Users are encouraged to report concerns promptly.
    </p>
    <hr class="col-12 my-3">

    <h5 class="col-12 fw-700 mt-3">5. No Campaign Agency or Coordination</h5>
    <p class="col-12 text-justify my-2 mb-4">
      Use of the App does not create an agency, partnership, or coordination relationship between the App and any candidate, campaign, or political committee. Candidates are solely responsible for compliance with applicable election, campaign finance, advertising, and disclosure laws related to their use of the App.
    </p>
  </div>
</div>
